var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { Get, Post } from "../api/api";
import { Config } from "../api/config";
import { APPLICATION_SETTINGS, WOH_AM_I_DATA, applicationSettings, changePasswordURL, getIdentityByMobileNo, loginOtpURL, verifySignIn, whoamiUrl } from "../api/url";
import { getLocalStorageItem, getWhoAmIToken, setLocalStorageItem } from "../utils/storageHelper";
import { GoogleAnlyticsErrorLog, handleServerSideErrors } from "../utils/utils";
import { showLoader, showNotification } from "./commonSlice";
import { t } from "i18next";
import { LOCAL_STORAGE_KEYS } from "../constants";
var initialState = {
    whoamiData: getLocalStorageItem(WOH_AM_I_DATA),
    identity: null,
    loginData: getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_LOGIN_DATA),
    getUserByIdentityId: null,
    status: "idle",
    getIdentityByMobileNo: null,
    getApplicationSetting: getLocalStorageItem(APPLICATION_SETTINGS)
};
export var whoAmIAPI = createAsyncThunk("whoami", function (request, _ref) { return __awaiter(void 0, void 0, void 0, function () {
    var dispatch, headers, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                dispatch = _ref.dispatch;
                headers = {
                    "Client-Id": Config.ClientID,
                    "Client-Secret": Config.ClientSecret,
                    Subscription: Config.Subscription
                };
                dispatch(showLoader({
                    isLoaderOpen: true
                }));
                return [4 /*yield*/, Get(whoamiUrl, {
                        headers: headers
                    })];
            case 1:
                response = _a.sent();
                if ((response === null || response === void 0 ? void 0 : response.statusCode) === 200) {
                    // altert(JSON.stringify('Success WHOAMI'+response))
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    setLocalStorageItem(WOH_AM_I_DATA, response);
                    return [2 /*return*/, response];
                }
                else {
                    // altert(JSON.stringify('ERROR WHOAMI'+response))
                    return [2 /*return*/, response];
                }
                return [2 /*return*/];
        }
    });
}); });
export var getApplicationSetting = createAsyncThunk("applicationsettings", function (request, _ref2) { return __awaiter(void 0, void 0, void 0, function () {
    var dispatch, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                dispatch = _ref2.dispatch;
                dispatch(showLoader({
                    isLoaderOpen: true
                }));
                return [4 /*yield*/, Get(applicationSettings)];
            case 1:
                response = _a.sent();
                if ((response === null || response === void 0 ? void 0 : response.statusCode) === 200) {
                    // altert(JSON.stringify('Success getApplicationSetting'+response))
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    setLocalStorageItem(APPLICATION_SETTINGS, response);
                    return [2 /*return*/, response];
                }
                else {
                    // altert(JSON.stringify('Error getApplicationSetting'+response))
                    return [2 /*return*/, response];
                }
                return [2 /*return*/];
        }
    });
}); });
export var loginAPI = createAsyncThunk("login", function (request, _ref3) { return __awaiter(void 0, void 0, void 0, function () {
    var dispatch, whoAMIData, response, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                dispatch = _ref3.dispatch;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                whoAMIData = getWhoAmIToken();
                dispatch(showLoader({
                    isLoaderOpen: true
                }));
                return [4 /*yield*/, Post(loginOtpURL, request, {
                        headers: {
                            Authorization: "Bearer ".concat(whoAMIData)
                        },
                        withCredentials: true
                    })];
            case 2:
                response = _a.sent();
                if ((response === null || response === void 0 ? void 0 : response.statusCode) === 200) {
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    dispatch(showNotification({
                        isOpen: true,
                        message: t("OTP sent successfully"),
                        type: "success"
                    }));
                    return [2 /*return*/, response];
                }
                else {
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    // dispatch(
                    //   showNotification({
                    //     isOpen: true,
                    //     message: response?.data.statusCode === 400 && response?.data?.message === "Validation error" ?  response.data.error[0][0].message : response?.data?.message,
                    //     type: "error",
                    //   })
                    // );
                    return [2 /*return*/, response];
                }
                return [3 /*break*/, 4];
            case 3:
                error_1 = _a.sent();
                dispatch(showLoader({
                    isLoaderOpen: false
                }));
                return [2 /*return*/, error_1];
            case 4: return [2 /*return*/];
        }
    });
}); });
export var changePasswordAPI = createAsyncThunk("changePassword", function (request, _ref4) { return __awaiter(void 0, void 0, void 0, function () {
    var dispatch, profileData, response, _response$data, error_2, profileData;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                dispatch = _ref4.dispatch;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                profileData = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA);
                return [4 /*yield*/, Post(changePasswordURL, request)];
            case 2:
                response = _a.sent();
                if ((response === null || response === void 0 ? void 0 : response.statusCode) === 200 || response !== null && response !== void 0 && response.success) {
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    dispatch(showNotification({
                        isOpen: true,
                        message: t("Change password successfully"),
                        type: "success"
                    }));
                    return [2 /*return*/, response];
                }
                else {
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    GoogleAnlyticsErrorLog(profileData, changePasswordURL, response === null || response === void 0 || (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.errorCode, request);
                    dispatch(showNotification({
                        isOpen: true,
                        message: response === null || response === void 0 ? void 0 : response.errorCode,
                        type: "error"
                    }));
                    return [2 /*return*/, response];
                }
                return [3 /*break*/, 4];
            case 3:
                error_2 = _a.sent();
                dispatch(showLoader({
                    isLoaderOpen: false
                }));
                profileData = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA);
                GoogleAnlyticsErrorLog(profileData, changePasswordURL, handleServerSideErrors(error_2, changePasswordURL, request), request);
                dispatch(showNotification({
                    isOpen: true,
                    message: handleServerSideErrors(error_2, changePasswordURL, request),
                    type: "error"
                }));
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); });
export var getUserByIdentityIdAPI = createAsyncThunk("userByIdentityId", function (IdentityId) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Get("".concat(Config.baseURL, "Identity/").concat(IdentityId, "/Get"))];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response];
        }
    });
}); });
export var verifyOtpAPI = createAsyncThunk("verifyOtp", function (request, _ref5) { return __awaiter(void 0, void 0, void 0, function () {
    var dispatch, response, _response$data2, _response$data3, profileData, error_3, profileData;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                dispatch = _ref5.dispatch;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, Post(verifySignIn, request)];
            case 2:
                response = _a.sent();
                if ((response === null || response === void 0 ? void 0 : response.statusCode) === 200 || response !== null && response !== void 0 && response.success) {
                    setLocalStorageItem(LOCAL_STORAGE_KEYS.USER_LOGIN_DATA, response);
                    return [2 /*return*/, response];
                }
                else {
                    profileData = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA);
                    GoogleAnlyticsErrorLog(profileData, verifySignIn, response === null || response === void 0 || (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.errorCode, request);
                    dispatch(showNotification({
                        isOpen: true,
                        message: response === null || response === void 0 || (_response$data3 = response.data) === null || _response$data3 === void 0 ? void 0 : _response$data3.errorCode,
                        //MSG_AP0008
                        type: "error"
                    }));
                    return [2 /*return*/, response];
                }
                return [3 /*break*/, 4];
            case 3:
                error_3 = _a.sent();
                dispatch(showLoader({
                    isLoaderOpen: false
                }));
                profileData = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA);
                GoogleAnlyticsErrorLog(profileData, verifySignIn, handleServerSideErrors(error_3, verifySignIn, request), request);
                dispatch(showNotification({
                    isOpen: true,
                    message: handleServerSideErrors(error_3, verifySignIn, request),
                    type: "error"
                }));
                dispatch(showLoader({
                    isLoaderOpen: false
                }));
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); });
export var getIdentityByMobileNoAPI = createAsyncThunk("getidentitybymobileno", function (request, _ref6) { return __awaiter(void 0, void 0, void 0, function () {
    var dispatch, response, profileData;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                dispatch = _ref6.dispatch;
                return [4 /*yield*/, Post(getIdentityByMobileNo, request)];
            case 1:
                response = _a.sent();
                dispatch(showLoader({
                    isLoaderOpen: true
                }));
                if ((response === null || response === void 0 ? void 0 : response.statusCode) === 200 || response !== null && response !== void 0 && response.success) {
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    return [2 /*return*/, response];
                }
                else {
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    profileData = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA);
                    GoogleAnlyticsErrorLog(profileData, getIdentityByMobileNo, response === null || response === void 0 ? void 0 : response.errorCode, request);
                    dispatch(showNotification({
                        isOpen: true,
                        message: response === null || response === void 0 ? void 0 : response.errorCode,
                        type: "error"
                    }));
                    return [2 /*return*/, response];
                }
                return [2 /*return*/];
        }
    });
}); });
export var authSlice = createSlice({
    name: "auth",
    initialState: initialState,
    reducers: {
        resetAfterLogOutAuth: function () { return initialState; }
    },
    extraReducers: function (builder) {
        builder.addCase(whoAmIAPI.pending, function (state) {
            state.status = "loading";
        }).addCase(whoAmIAPI.fulfilled, function (state, action) {
            state.status = "idle";
            state.whoamiData = action.payload;
        }).addCase(whoAmIAPI.rejected, function (state) {
            state.status = "failed";
            state.whoamiData = null;
        }).addCase(getApplicationSetting.pending, function (state) {
            state.status = "loading";
        }).addCase(getApplicationSetting.fulfilled, function (state, action) {
            state.status = "idle";
            state.getApplicationSetting = action.payload;
        }).addCase(getApplicationSetting.rejected, function (state) {
            state.status = "failed";
            state.getApplicationSetting = null;
        }).addCase(verifyOtpAPI.pending, function (state) {
            state.status = "loading";
        }).addCase(verifyOtpAPI.fulfilled, function (state, action) {
            state.status = "idle";
            state.loginData = action.payload;
        }).addCase(verifyOtpAPI.rejected, function (state) {
            state.status = "failed";
            state.loginData = null;
        }).addCase(getIdentityByMobileNoAPI.pending, function (state) {
            state.status = "loading";
        }).addCase(getIdentityByMobileNoAPI.fulfilled, function (state, action) {
            state.status = "idle";
            state.getIdentityByMobileNo = action.payload;
        }).addCase(getIdentityByMobileNoAPI.rejected, function (state) {
            state.status = "failed";
            state.getIdentityByMobileNo = null;
        });
    }
});
export var resetAfterLogOutAuth = authSlice.actions.resetAfterLogOutAuth;
var authReducer = authSlice.reducer;
export default authReducer;
